export default __webpack_public_path__ + "static/media/mobile2.0dfd4833.jpg";